export default __webpack_public_path__ + "static/media/profile.aee80dc8.svg";